import { Link } from "react-router-dom";
import { getCategoryById, formatDate, formatViews } from "@/lib/videos";
import type { VideoItem } from "@/mocks/videos";

interface VideoCardProps {
  video: VideoItem;
  compact?: boolean;
}

export default function VideoCard({ video, compact = false }: VideoCardProps) {
  const category = getCategoryById(video.categoryId);

  return (
    <article className="group">
      <Link to={`/detail/${video.id}`} className="block cursor-pointer">
        <div className="relative w-full overflow-hidden rounded-lg bg-secondary-200" style={{ aspectRatio: "16 / 9" }}>
          <img
            src={video.cover}
            alt={`${video.title} 视频封面`}
            title={`${video.title} - ${category ? category.name : ""}`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/5 to-transparent" />
          <span className="absolute left-2 top-2 inline-flex items-center rounded-full bg-background-50/95 px-2.5 py-0.5 text-[11px] font-medium text-primary-800">
            {category ? category.name : "赛事"}
          </span>
          <span className="absolute right-2 top-2 inline-flex items-center rounded bg-foreground-950/70 px-1.5 py-0.5 font-label text-[11px] text-background-50">
            {video.duration}
          </span>
          <span className="absolute bottom-2 left-2 font-label text-[11px] tracking-wide text-background-100">
            {video.episode}
          </span>
          <span className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500/95 text-primary-950">
              <i className="ri-play-fill text-xl" />
            </span>
          </span>
        </div>

        <h3
          className={`mt-3 font-heading font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 ${
            compact ? "text-[14px]" : "text-[15px] md:text-base"
          }`}
        >
          {video.title}
        </h3>

        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="font-label tracking-wide">{formatDate(video.uploadedAt)}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300" />
          <span>{formatViews(video.views)} 次观看</span>
          <span className="hidden h-1 w-1 rounded-full bg-foreground-300 sm:block" />
          <span className="hidden sm:inline">{video.region}</span>
        </div>
      </Link>
    </article>
  );
}